module.exports = __webpack_public_path__ + "img/ic_back_active_dark_grey.1d79f8c2.svg";